import * as React from 'react';

export const LittlePremiumIcon = (isHovered: boolean, props?: React.HTMLAttributes<SVGElement>) => (
  // eslint-disable-next-line react/forbid-elements
  <svg {...props} height="14" viewBox="0 0 14 14" width="14" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.292 12.707l1.939.646-.646.647H0v-2.585l.646-.646.646 1.938zm10.466-10.46c-.287-.29-1.219.153-1.65.589-.429.435-.545 1.023-.258 1.313.286.29.867.172 1.297-.263.43-.435.898-1.35.61-1.64zm.239 3.329L7.002 10.58V14h-1.4l-.806-1.21.299-.901-1.5-1.503.6.601-.6 1.803-.6-1.803-1.8-.6 1.8-.603-.9-.902-.9.301L0 8.399v-1.4h3.376l5.02-5.03S12.912-.722 13.82.187c.892.894-1.823 5.388-1.823 5.388z"
      fill={isHovered ? '#CC6E09' : '#FF8400'}
      fillRule="evenodd"
    />
  </svg>
);
